import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.path('/languages/{?id}')
@doc.timestampable
abstract class AbstractLanguageModel extends Blamable(WebsiteServiceModel) {
	declare protected _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'locale': LanguageKey;
		'search': string;
	};

	declare private _tsSorts: {
		id: string;
		name: string;
		locale: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare name: string;
	@doc.string declare locale: LanguageKey;
}

interface AbstractLanguageModel extends Timestampable {}

export default AbstractLanguageModel;
